import React, { useEffect, useState } from 'react';
import { Button } from '../primitives/button/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../dialog/dialog';
import { Input } from '../primitives/imput/input';
import { Checkbox } from '../primitives/checkbox/checkbox';
import { IMaskInput } from "react-imask";

import { cn } from 'lib/utils'

import { useConsentStore } from "../../../lib/store/consent-store";
import { useSendForm } from "../../../lib/hooks/use-send-form";

export interface Flat {
  image: string;
  title: string;
  price: string;
  priceNumber?: number;
  oldPrice: string;
  oldPriceNumber?: number;
  commonSpace: string;
  livingSpace: string;
  dialogTitle: string;
  firstText?: string;
  secondText?: string;
}
interface ApartsmentLayoutsItemProps {
  apartment: Flat;
  selectTab: string;
}

export const ApartsmentLayoutsItem = ({
  apartment,
  selectTab,
}: ApartsmentLayoutsItemProps) => {

  const consent = useConsentStore(state => state.consent);
  const updateConsent = useConsentStore(state => state.updateConsent);

  const [termsChecked, setTermsChecked] = useState(false);
  const [termsError, setTermsError] = useState(false)
  const [fieldsError, setFieldsError] = useState(false)

  const [success, setSuccess] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    text: apartment.title
  })

  useEffect(() => {
    setFieldsError(false)
  }, [formData])

  useEffect(() => {
    setTermsError(false)
  }, [termsChecked]);

  const handleInputChange = (value: string, name: string) => {
    setFormData({ ...formData, [name]: value })
  }

  const validateFormAndSend = () => {
    if (formData.name === '' || formData.phone === '') {
      setFieldsError(true)
      return
    }

    if (formData.phone !== '') {
      const cleaned = formData.phone.replace(/\D/g, '');
      const isDigitsOnly = /^\d+$/.test(cleaned);
      const isValidLength = cleaned.length >= 10 && cleaned.length <= 15;

      if (isDigitsOnly && isValidLength) {

      } else {
        setFieldsError(true)
      }
    }

    if (!termsChecked) {
      setTermsError(true)
      return
    }

    sendForm(formData, 'getFlatPrice', () => {
      setSuccess(true)
    })
  }

  const { sendForm, isPending, error } = useSendForm()

  return (
    <div
      className="flex flex-col justify-between py-5 h-full bg-plt-black/5 rounded-[20px] rounded-bl-none font-open-sans">
      <div className="w-full flex justify-center items-center min-h-[190px] h-full">
        <img className='max-h-[200px] h-full' src={apartment.image} alt={apartment.title} />
      </div>
      <div>
        <h5 className="text-center text-plt-black font-semibold leading-[120%] mt-2">
          {apartment.title}
        </h5>
        <div className='flex flex-col justify-center items-center'>
          <Dialog>
            <DialogTrigger asChild>
              <Button className="mt-6 font-semibold text-plt-white w-fit">
                {selectTab === "3 корпус" ? apartment.price : "Узнать стоимость"}
              </Button>
            </DialogTrigger>
            <DialogContent className="bg-[#FAFAFC] border-none w-[670px] max-h-full screen-500:w-screen screen-500:overflow-y-scroll">
              <DialogHeader>
                <DialogTitle className="text-center text-4xl">
                  {apartment.dialogTitle}
                </DialogTitle>
              </DialogHeader>
              <div className="flex justify-between mt-5 screen-600:flex-col-reverse screen-600:items-center">
                <div className=' shrink-0 screen-500:shrink flex-col flex justify-between basis-1/2'>
                  <div>
                    <p className='text-xl'>
                      Общая площадь:{' '}
                      <span className="font-bold">{apartment.commonSpace}</span>
                    </p>
                    <p className='text-xl'>
                      Жилая площадь:{' '}
                      <span className="font-bold">{apartment.livingSpace}</span>
                    </p>
                  </div>
                  <div className='flex flex-wrap'>
                    {apartment.priceNumber && apartment.oldPriceNumber && (
                      <div className='w-full text-center my-3'>
                        <p className='text-xl'>
                          {selectTab === "3 корпус" ? `${apartment.priceNumber?.toLocaleString('ru-RU')} руб` : "обновляем цены"}
                        </p>
                        <p className='text-xl line-through'>
                          {selectTab === "3 корпус" ? `${apartment.oldPriceNumber?.toLocaleString('ru-RU')} руб` : "обновляем цены"}
                        </p>
                      </div>
                    )}
                    <div className='w-full flex items-stretch gap-3'>
                      {apartment.firstText && (<div className='font-bold text-white bg-plt-secondary rounded px-5 py-3 grow text-center'>{apartment.firstText}</div>)}
                      {apartment.secondText && (<div className='font-bold text-white bg-plt-secondary rounded px-5 py-3 grow text-center'>{apartment.secondText}</div>)}
                    </div>
                  </div>
                </div>
                <div className='basis-1/3'>
                  <img src={apartment.image} alt={apartment.title} className='max-h-[300px]' />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-1 mt-5 screen-600:grid-cols-1">
                <Input value={formData.name}
                  onChange={e => handleInputChange(e.target.value, 'name')}
                  placeholder="Ваше имя" />
                <IMaskInput
                  value={formData.phone}
                  onAccept={value => handleInputChange(value, 'phone')}
                  mask={'+7 (000) 000-00-00'}
                  placeholder={'Ваш телефон'}
                  className={cn(
                    'ym-record-keys placeholder:text-plt-dark-gray selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-plt-gray flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                    'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
                    'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
                    'rounded-[5px]'
                  )} />
                <Button disabled={isPending} onClick={validateFormAndSend} className="font-bold">Узнать
                  подробнее</Button>
                {termsError &&
                  <p className='text-xs text-red-500'>Пожалуйста, дайте согласие на обработку персональных данных</p>}
                {fieldsError && <p className='text-xs text-red-500'>Пожалуйста, заполните все поля перед отправкой</p>}
              </div>
              {success &&
                <p className='py-3 rounded text-center text-xs text-green-500 border border-solid border-green-500'>Форма
                  успешно
                  отправлена, спасибо!</p>}
              <div className="flex items-center gap-2">
                <Checkbox
                  checked={termsChecked}
                  onCheckedChange={(checked) => setTermsChecked(checked === true)}
                  id="apartment-terms"
                  className="border-[#D3D3D3] rounded-[1px]"
                />
                <label
                  htmlFor="apartment-terms"
                  className="tracking-[-3%] text-[#989898]"
                >
                  Нажимая кнопку «Узнать подробнее», вы даете согласие на обработку
                  персональных данных и соглашаетесь с политикой конфиденциальности
                </label>
              </div>
              <div className="flex items-center gap-2">
                <Checkbox id={'consent'} checked={consent}
                  onCheckedChange={(checked) => updateConsent(checked === true)}
                  className="border-[#D3D3D3] rounded-[1px]" />
                <label className="tracking-[-3%] text-[#989898]" htmlFor='consent'>
                  Я ознакомлен (-на) с правилами обработки куки
                </label>
              </div>
            </DialogContent>
          </Dialog>
          {selectTab === "3 корпус" && (
            <span className='relative text-[#8D8D8D] mt-2 font-light'>{apartment.oldPrice}
              <div className='absolute top-1/2 -translate-y-1/2 left-0 right-0 -rotate-6 h-px bg-[#8D8D8D]' /></span>
          )}

        </div>
      </div>

    </div>
  );
};
